import _ from 'underscore';

export function restoreScrollBarPosition(view, selector) {
  let scrollTop = 0;

  view.on('rendered', () => {
    view.$(selector).scrollTop(scrollTop);
  });

  view.el.addEventListener('scroll', _.debounce((e) => {
    if (e.target === view.el.querySelector(selector)) {
      ({ scrollTop } = e.target);
    }
  }, 100), true);
}
